<template>
  <v-menu
    offset-y
  >
    <v-btn
      slot="activator"
      flat
      icon
      small
      color="info lighten-2"
      class="ma-0"
    >
      <v-icon small>
        help
      </v-icon>
    </v-btn>
    <div>
      <v-card class="light-blue lighten-5">
        <v-card-text style="width: 380px">
          <span class="deep-orange--text">體積重量</span>計算方法：<br>
          空運包裹長x寬x高/6000=體積重量<br>
          體積重量與實際重量取較大的重量計重<br>
          體積重量大於實際重量3倍以內全部優惠（即按實際重量計重）<br>
          體積重量大於實際重量3倍以上享有50%優惠（即按體積重量/2計重）
        </v-card-text>
      </v-card>
    </div>
  </v-menu>
</template>

<script>
export default {

}
</script>

<style>

</style>
